/* =========================================
   INIT VARIANT AUTO SELECTION
========================================= */
function initVariantSelection($tab) {
  const variants = JSON.parse(
    $tab.find('.product-variants-json').html()
  ).variants;

  const $flavorSelect = $tab.find('.variant-flavor');
  const $packWrap = $tab.find('.variant-pack');
  const hasFlavorOption = $flavorSelect.length > 0;

  $packWrap.find('button').removeClass('is-active');

  if (hasFlavorOption && $packWrap.length) {
    const firstPackBtn = $packWrap.find('button').first();
    if (firstPackBtn.length) firstPackBtn.addClass('is-active');
  }

  if (!hasFlavorOption) {
    const firstAvailable = variants.find(v => v.available);
    if (firstAvailable && $packWrap.length) {
      const packIndex = $packWrap.data('index');
      const packValue = firstAvailable.options[packIndex];

      $packWrap.find('button').each(function () {
        if ($(this).data('value') === packValue) {
          $(this).addClass('is-active');
        }
      });
    }
  }
}

   setTimeout(function() {
  $("#appstle_selling_plan_label_12").click();
}, 2000);

/* =========================================
   MAIN SCRIPT
========================================= */
$(function () {

  const $mainSection = $('#experience-tabs-cstm');

  /* -------- Tabs -------- */
  initVariantSelection($('.experience-tab.is-active'));
  $mainSection.addClass('tab-1-active');

  $('.experience-tab-btn').on('click', function () {
      setTimeout(function () {

  const $oneTimeInput = $activeTab.find(
    '.appstle_one_time_details_wrapper input[type="radio"]'
  );

  if ($oneTimeInput.length) {
    $oneTimeInput.prop('checked', true).trigger('change');
  }

}, 500);

    const tabId = $(this).data('tab');
    const tabIndex = $(this).index();

    $('.experience-tab-btn').removeClass('is-active');
    $(this).addClass('is-active');

    $('.experience-tab').removeClass('is-active');
    const $activeTab = $('#' + tabId).addClass('is-active');

    $mainSection.removeClass(function (i, className) {
      return (className.match(/(^|\s)tab-\d+-active/g) || []).join(' ');
    });

    $mainSection.addClass('tab-' + (tabIndex + 1) + '-active');

    initVariantSelection($activeTab);

    /* Auto select one-time purchase */
    setTimeout(function () {
      const $oneTimeInput = $activeTab.find(
        '.appstle_one_time_details_wrapper input[type="radio"]'
      );
      if ($oneTimeInput.length) {
        $oneTimeInput.prop('checked', true).trigger('change');
      }
    }, 400);
  });


  /* -------- Variants + Cart Logic -------- */
  $('.experience-tab').each(function () {

    const $tab = $(this);
    const variants = JSON.parse(
      $tab.find('.product-variants-json').html()
    ).variants;

    const isSingleVariant = variants.length === 1;
    const singleVariantId = isSingleVariant ? variants[0].id : null;

    const $flavorSelect = $tab.find('.variant-flavor');
    const $packWrap = $tab.find('.variant-pack');
    const $buyBtn = $tab.find('#Buy-now-custom-cl');
    const $addToCartBtn = $tab.find('.cart-to-cart');
    const $errorMsg = $tab.find('.variant-error-msg');

    let selectedOptions = [];
    let lastSelectedPackValue = null;
    /* 🔥 UPDATE SUBSCRIPTION PRICE ON VARIANT CHANGE */

    /* 🔥 UPDATE SUBSCRIPTION + ONE TIME PRICE */
function updateSubscriptionPrice(matchedVariant) {

  if (!matchedVariant) return;

  const variantPrice = matchedVariant.price / 100;
  const comparePrice = matchedVariant.compare_at_price
    ? matchedVariant.compare_at_price / 100
    : null;

  const discountPercent = 15; // 👈 change if needed
  const subscriptionPrice = variantPrice * (1 - discountPercent / 100);
  function formatMoney(val) {
    return '$' + val.toFixed(2);
  }



/* ===============================
   🔥 UPDATE SUBSCRIPTION PRICE
================================ */

const $subscriptionAmount = $tab.find('.appstle_subscription_amount');
const $subscriptionCompare = $tab.find(
  '.appstle_subscription_compare_amount, .appstle_subscription_compare_at_price'
);

// Update discounted subscription price
if ($subscriptionAmount.length) {
  $subscriptionAmount.text(formatMoney(subscriptionPrice));
}

// 🔥 Force compare price = original variant price
if ($subscriptionCompare.length) {
  $subscriptionCompare
    .text(formatMoney(variantPrice))
    .show();
}



 /* ===============================
   🔥 UPDATE ONE TIME PRICE (FIXED)
================================ */
const $oneTimeWrapper = $tab.find('.appstle_one_time_price_wrapper');

if (!$oneTimeWrapper.length) return;

$oneTimeWrapper.empty(); // clear everything safely

// Always show main price
$oneTimeWrapper.append(
  '<span class="one-time-main-price">' + formatMoney(variantPrice) + '</span>'
);

// Show compare price only if valid
if (comparePrice && comparePrice > variantPrice) {
  $oneTimeWrapper.append(
    '<span class="one-time-compare-price" style="margin-left:8px;text-decoration:line-through;opacity:0.6;">' +
    formatMoney(comparePrice) +
    '</span>'
  );
}

}

    function showError(text) {
      $errorMsg.text(text).show();
    }

    function clearError() {
      $errorMsg.hide().text('');
    }

    /* Disable unavailable options */
    if ($flavorSelect.length) {
      const flavorIndex = $flavorSelect.data('index');

      $flavorSelect.find('option').each(function () {
        const val = $(this).val();
        if (!val) return;

        const available = variants.some(
          v => v.options[flavorIndex] === val && v.available
        );

        if (!available) $(this).prop('disabled', true);
      });
    }

    if ($packWrap.length) {
      const packIndex = $packWrap.data('index');

      $packWrap.find('button').each(function () {
        const val = $(this).data('value');

        const available = variants.some(
          v => v.options[packIndex] === val && v.available
        );

        if (!available) $(this).addClass('is-disabled');
      });
    }

    /* Flavor change */
    $flavorSelect.on('change', function () {

      clearError();
      const flavorValue = $(this).val();
      if (!flavorValue) return;

      const flavorIndex = $(this).data('index');
      const packIndex = $packWrap.data('index');

      let hasValidPreviousPack = false;

      $packWrap.find('button').each(function () {
        const packValue = $(this).data('value');

        const available = variants.some(
          v =>
            v.options[flavorIndex] === flavorValue &&
            v.options[packIndex] === packValue &&
            v.available
        );

        $(this).toggleClass('is-disabled', !available);

        if (available && packValue === lastSelectedPackValue) {
          hasValidPreviousPack = true;
        }
      });

      if (!hasValidPreviousPack) {
        const firstAvailable = $packWrap.find('button:not(.is-disabled)').first();
        if (firstAvailable.length) {
          $packWrap.find('button').removeClass('is-active');
          firstAvailable.addClass('is-active');
          lastSelectedPackValue = firstAvailable.data('value');
        }
      }
      // 🔥 Update subscription price
const matched = variants.find(
  v =>
    v.available &&
    v.options[flavorIndex] === flavorValue &&
    v.options[packIndex] === $packWrap.find('button.is-active').data('value')
);

updateSubscriptionPrice(matched);
    });

    /* Pack click */
    $packWrap.on('click', 'button', function () {
      if ($(this).hasClass('is-disabled')) return;

      $packWrap.find('button').removeClass('is-active');
      $(this).addClass('is-active');
      lastSelectedPackValue = $(this).data('value');
      clearError();
      const flavorIndex = $flavorSelect.data('index');
const packIndex = $packWrap.data('index');

let selectedOptions = [];

if ($flavorSelect.length) {
  selectedOptions[flavorIndex] = $flavorSelect.val() || '';
}
selectedOptions[packIndex] = $(this).data('value');

const matched = variants.find(
  v =>
    v.available &&
    v.options.every((opt, i) => selectedOptions[i] === opt)
);

updateSubscriptionPrice(matched);
    });

    /* Get Selling Plan */
    function getSellingPlan() {
      const $widget = $tab.find('.appstle_sub_widget');
      return $widget.length
        ? $widget.attr('data-selected-selling-plan')
        : null;
    }

    /* BUY NOW */
    $buyBtn.on('click', function () {

      clearError();
      let sellingPlanId = getSellingPlan();

      function redirect(cartData) {
        $.post('/cart/add.js', cartData, function () {
          window.location.href = '/checkout';
        });
      }

      if (isSingleVariant && singleVariantId) {
        let data = { id: singleVariantId, quantity: 1 };
        if (sellingPlanId) data.selling_plan = sellingPlanId;
        redirect(data);
        return;
      }

      selectedOptions = [];

      if ($flavorSelect.length) {
        const flavorIndex = $flavorSelect.data('index');
        if (!$flavorSelect.val()) {
          showError('Please select a flavor to continue');
          return;
        }
        selectedOptions[flavorIndex] = $flavorSelect.val();
      }

      if ($packWrap.length) {
        const packIndex = $packWrap.data('index');
        selectedOptions[packIndex] =
          $packWrap.find('button.is-active').data('value') || '';
      }

      const matched = variants.find(
        v =>
          v.available &&
          v.options.every((opt, i) => selectedOptions[i] === opt)
      );

      if (!matched) {
        showError('Selected variant is not available');
        return;
      }

      let data = { id: matched.id, quantity: 1 };
      if (sellingPlanId) data.selling_plan = sellingPlanId;

      redirect(data);
    });


    /* ADD TO CART */
    $addToCartBtn.on('click', function () {

      const $button = $(this);
      const originalText = $button.text();
      clearError();

      let sellingPlanId = getSellingPlan();

     function ajaxAdd(cartData) {

  $.post('/cart/add.js', cartData, function () {

    // 🔥 Change button text
    $button.text('Added');

    // 🔥 Update Cart Drawer
    fetch(window.Shopify.routes.root + '?sections=cart-drawer')
  .then(response => response.json())
  .then(data => {

    const drawerHTML = new DOMParser()
      .parseFromString(data['cart-drawer'], 'text/html')
      .querySelector('#CartDrawer');

    const currentDrawer = document.querySelector('#CartDrawer');

    if (drawerHTML && currentDrawer) {
      currentDrawer.innerHTML = drawerHTML.innerHTML;
    }

    const cartDrawer = document.querySelector('cart-drawer');
     $('.cart-button .icon-wrapper').trigger('click');
    if (cartDrawer && cartDrawer.open) {
      cartDrawer.open();
    }

  });


    // 🔥 Reset button text after 1 sec
    setTimeout(() => {
      $button.text(originalText);
    }, 5000);

  });

}

      if (isSingleVariant && singleVariantId) {
        let data = { id: singleVariantId, quantity: 1 };
        if (sellingPlanId) data.selling_plan = sellingPlanId;
        ajaxAdd(data);
        return;
      }

      selectedOptions = [];

      if ($flavorSelect.length) {
        const flavorIndex = $flavorSelect.data('index');
        if (!$flavorSelect.val()) {
          showError('Please select a flavor to continue');
          return;
        }
        selectedOptions[flavorIndex] = $flavorSelect.val();
      }

      if ($packWrap.length) {
        const packIndex = $packWrap.data('index');
        selectedOptions[packIndex] =
          $packWrap.find('button.is-active').data('value') || '';
      }

      const matched = variants.find(
        v =>
          v.available &&
          v.options.every((opt, i) => selectedOptions[i] === opt)
      );

      if (!matched) {
        showError('Selected variant is not available');
        return;
      }

      let data = { id: matched.id, quantity: 1 };
      if (sellingPlanId) data.selling_plan = sellingPlanId;

      ajaxAdd(data);
    });

  });

});

